var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-toggle",on:{"click":this.toggleNav}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',[_c('span',{staticClass:"toggle-icon"},[_c('span'),_c('span'),_c('span')])])
}]

export { render, staticRenderFns }